






























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {DistrictParams} from "../../params";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {debounce} from "lodash";
import {DistrictStore} from "@/modules/regionsv2/district/store";
import DistrictForm from "@/modules/regionsv2/district/Form/index.vue";
import ProvinceSelectorV2 from "@/modules/regionsv2/ProvinceSelectorV2/index.vue";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
    name: 'DistrictSearch',
    components: {ProvinceSelectorV2, DistrictForm, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    params = new DistrictParams();
    CommonStatus = CommonStatus;
    visibleForm = false;

    @Watch("params", { immediate: true, deep: true })
    onChangeParams(val) {
        this.handleChangeParams(val);
    }

    handleChangeParams = debounce((val) => {
        DistrictStore.paramsChangeDistrictV21({ ...val, page: 1 });
    }, 300)

    create() {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_CREATE_REGION)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        this.visibleForm = true;
    }
}
